export function compareArray(a, b, comparator) {
	let result = true;

	if(a.length !== b.length) {
		// if lengths don't match, early escape with don't match
		result = false;
	} else {
		for(let i = 0; i < a.length; i++) {
			// callback should return true if a[i] and b[i] matches based
			// on the comparator predicate
			result = comparator(a[i], b[i]);

			// if result is now false, i.e. we found something that doesn't match
			// break comparison loop now as there is no point continuing.
			if(!result) {
				break;
			}
		}
	}

	return result;
}

export function exists(arr, value, comparator) {
	let result = true;

	for(let i = 0; i < arr.length; i++) {
		result = comparator(arr[i], value);
		if(!result) { break; }
	}

	return result;
}


/** WEBPACK FOOTER **
 ** ./src/modules/common/ArrayUtils.js
 **/